/**
 * Taken, CommonJS-ified, and heavily modified from:
 * https://github.com/flyingsparx/NodeDirectUploader
 * https://raw.githubusercontent.com/odysseyscience/react-s3-uploader/master/s3upload.js
 */

declare const XDomainRequest: $TSFixMe;

type Options = {
  getSignedUrl: $TSFixMe;
  contentType?: string;
  onFinishS3Put: (signResult: { signedUploadUrl: string }) => void;
  onProgress?: (percent: number, status: string) => void;
  onError?: (status: string) => void;
};

export default class S3Upload {
  declare options: Options;

  constructor(options: Options) {
    this.options = options;
  }

  handleFileSelect = (file: File) => {
    if (this.options.onProgress) {
      this.options.onProgress(0, 'Upload started.');
    }
    const uploadToS3Callback = this.uploadToS3.bind(this, file);
    return this.options.getSignedUrl(uploadToS3Callback);
  };

  createCORSRequest = (method: string, url: string) => {
    let xhr: XMLHttpRequest | null = new XMLHttpRequest();

    if (xhr.withCredentials != null) {
      xhr.open(method, url, true);
    } else if (typeof XDomainRequest !== 'undefined') {
      xhr = new XDomainRequest();
      if (xhr) {
        xhr.open(method, url);
      }
    } else {
      xhr = null;
    }
    return xhr;
  };

  uploadToS3 = (file: File, signResult: { signedUploadUrl: string }) => {
    const { onError, onProgress, contentType = 'text/csv' } = this.options;
    return new Promise((resolve, reject) => {
      const xhr = this.createCORSRequest('PUT', signResult.signedUploadUrl);
      if (!xhr) {
        if (onError) onError('CORS not supported');
      } else {
        xhr.onload = () => {
          if (xhr.status === 200) {
            if (onProgress) onProgress(100, 'Upload completed.');
            resolve(this.options.onFinishS3Put(signResult));
          } else {
            const error = 'Upload error: ' + xhr.status;
            if (onError) onError(error);
            reject(error);
          }
        };
        xhr.onerror = () => {
          const error = 'XHR error.';
          if (onError) onError(error);
          reject(error);
        };
        xhr.upload.onprogress = (e) => {
          let percentLoaded;
          if (e.lengthComputable) {
            percentLoaded = Math.round((e.loaded / e.total) * 100);
            if (onProgress) onProgress(percentLoaded, percentLoaded === 100 ? 'Finalizing.' : 'Uploading.');
          }
        };
      }
      if (!xhr) return;
      xhr.setRequestHeader('Content-Type', contentType);
      xhr.send(file);
    });
  };
}
